/* import __COLOCATED_TEMPLATE__ from './http-api-code-sample.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();